export const mapValueToOption = (
  id: string,
  value: string,
  description: string,
) => ({
  id,
  value,
  description,
})
